import { CognitoIdToken } from "../users/authTypes";
import { OrderTicketId, asAmount, asBondPriceNominal } from "@goodfill/domain-properties";
import { Fetcher } from "../../fetcher";
import { z } from "zod";
import { zDecimal } from "@goodfill/domain-properties-zod-validators";

const orderModifyRequestSchema = z.object({
  faceAmount: zDecimal().transform(asAmount),
  bondPrice: zDecimal().transform(asBondPriceNominal),
});

export type OrderModifyRequest = z.infer<typeof orderModifyRequestSchema>;

const schema = z.object({ orderModifyRequests: z.array(orderModifyRequestSchema) });

export type OrderModifyRequestOutputData = z.infer<typeof schema>;

export type OrderModifyRequestInputData = { orderId: OrderTicketId };

export const orderModifyRequest = (
  fetcher: Fetcher,
  data: OrderModifyRequestInputData,
  cognitoIdToken: CognitoIdToken,
) =>
  fetcher({
    endpoint: `/traderUi/orderModifyRequest/${data.orderId}`,
    method: "GET",
    data: { orderId: `${data.orderId}` },
    cognitoIdToken,
    schema,
  });
